<template>
    <div class="lease-wh-mip-msg">
        <section v-if="mipBizInfo">
            <div class="sub-title">租仓方案信息</div>
            <el-input type="textarea" :value="mipBizInfo" :rows="10" :disabled="true" />
        </section>
        <section class="table-section" v-if="tableData && tableData.length">
            <div class="sub-title">租仓方案展示</div>
            <el-table :data="tableData" border v-loading="loading">
                <el-table-column prop="supplierName" label="供应商名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="whName" label="仓库名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="unitPrice" label="单价(元/平方米)" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="whSquare" label="仓库建筑面积（㎡）" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="propertyOwner" label="产权人" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="lessorName" label="出租方名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="ckpsfa" label="仓库评审方案">
                    <template slot-scope="scope">
                        <div v-if="scope.row.ckpsfa">
                            <el-button type="text" @click="handlePreview(scope.row.ckpsfa)">预览</el-button>
                            <el-button type="text" @click="handleDownload(scope.row.ckpsfa, scope.row)">下载</el-button>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="ptckfaps" label="平台仓库方案评审">
                    <template slot-scope="scope">
                        <div v-if="scope.row.ptckfaps">
                            <el-button type="text" @click="handlePreview(scope.row.ptckfaps)">预览</el-button>
                            <el-button type="text" @click="handleDownload(scope.row.ptckfaps, scope.row)">下载</el-button>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="ckxyxxdjb" label="仓库寻源信息登记表">
                    <template slot-scope="scope">
                        <div v-if="scope.row.ckxyxxdjb">
                            <el-button type="text" @click="handlePreview(scope.row.ckxyxxdjb)">预览</el-button>
                            <el-button type="text" @click="handleDownload(scope.row.ckxyxxdjb, scope.row)">下载</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="otherFile" label="其他附件（可打包）">
                    <template slot-scope="scope">
                        <div v-if="scope.row.otherFile">
                            <el-button type="text" @click="handlePreview(scope.row.otherFile)">预览</el-button>
                            <el-button type="text" @click="handleDownload(scope.row.otherFile, scope.row)">下载</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <m-page :currentPage="page.currentPage" :pageData="page.pageData" :total="page.total" @on-size-change="handleSizeChange" @on-page-change="handlePageChange"></m-page>
        </section>
        <section class="radio-section" v-if="whBizType">
            <span  class="sub-title">人工决策</span>
            <MRadio :value="whBizType" :dictCode="'SRM_WH_BIZ_TYPE'" :disabled="true" />
        </section>
        <!-- 预览 -->
        <Preview v-if="attachmentShow" :attachmentShow.sync="attachmentShow" :rowData="fileRowData"></Preview>
    </div>
</template>
<script>
import { queryByFdId, queryPageByFdId } from '../../../../../api/physicalStorage.js'
import MPage from '@/components/supplierPanel/mPage';
import MRadio from '../../../../../components/MRadio.vue';
import Preview from '../../../../../components/viewAttachment.vue';

export default {
    components: { MPage, MRadio, Preview },
    props: {
        fdId: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            loading: false,
            attachmentShow: false,
            fileRowData: {},
            dictData: {},
            tableData: [],
            leaseFileList: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageData: {
                    pageSize: 10,
                    pageSizes: [10]
                }
            },
            mipBizInfo: null,
            whBizType: null,
        };
    },
    methods: {
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.loadTableData();
        },
        handlePageChange(val) {
            this.page.currentPage = val;
            this.loadTableData();
        },
        loadData() {
            queryByFdId({ fdId: this.fdId }).then(res => {
                if (res && +res.code === 0 && res.data ) {
                    this.mipBizInfo = res.data.mipBizInfo;
                    this.whBizType = res.data.whBizType;
                }
            }).catch(err => {})
        },
        loadTableData() {
            this.loading = true;
            const params = {
                pageNo: this.page.currentPage,
                pageSize: this.page.pageSize,
                fdId: this.fdId
            }
            queryPageByFdId(params).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list.map(item => {
                        if (item.leaseFileList && item.leaseFileList.length)  {
                            let otherObj = item.leaseFileList.find(li => li.qualificationName === '其他附件（可打包）');
                            item.ckpsfa = item.leaseFileList.find(li => li.qualificationName === '仓库评审方案').fileUrl
                            // item.ptckfaps = item.leaseFileList.find(li => li.qualificationName === '平台仓库方案评审').fileUrl
                            item.ckxyxxdjb = item.leaseFileList.find(li => li.qualificationName === '仓库寻源信息登记表').fileUrl
                            item.otherFile = otherObj&&otherObj.fileUrl
                        }
                        return item
                    });
                    this.page.total = res.data.totalCount;
                }
            }).finally(() => { this.loading = false; })
        },
        handlePreview(downUrl) {
            this.attachmentShow = true;
            this.fileRowData = { downUrl };
        },
        handleDownload(downUrl, row) {
            const { fileName } = row.leaseFileList.find(item => item.fileUrl === downUrl)
            const a = document.createElement('a')
            a.href = downUrl
            a.download = fileName
            a.click()
        },
    },
    mounted() {
        this.loadData();
        this.loadTableData();
    },
};
</script>
<style lang="less">
.lease-wh-mip-msg {
    // padding: 10px;
    // border: 1px solid #cecece;

    .el-textarea{
        font-size: 14px;
    }
    section {
        margin-bottom: 15px;
    }

    .sub-title {
        margin-bottom: 10px;
    }

    .table-section {
        overflow: hidden;

        .el-table {
            margin-bottom: 10px
        }
    }

    .el-radio-group {
        margin-left: 15px;
    }
}
</style>